import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useHistory } from "react-router-dom";
import "./evaluationReference.css";

import { useDispatch, useSelector } from "react-redux";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import iconChat from "../../../assets/images/icon-chat.svg";
import { ClearGrille } from "../../../redux/actions/grille";
import "react-datepicker/dist/react-datepicker.css";
import PopoverBonus from "../AddEval/PopoverBonus";
import Popovermalus from "../AddEval/Popovermalus";
import { createEvalReference } from "../../../redux/actions/evaluation";


const EvaluationReference = forwardRef((props, ref) => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const { datagrilleselecet } = useSelector((state) => state.grille);
  props?.grille?.CriteriaGroup?.forEach((group) => {
    group.Criteria.sort((a, b) => a.id - b.id);
  });

  const [colorParam, setColorParam] = useState({
    id: 0,
    idg: 0,
    color: null,
    name: null,
    comment: null,
  });
  const [displayParam, setDisplayParam] = useState({
    statuse: false,
    idc: 0,
    idg: 0,
  });
  const transformData = (data) => {
    const result = [];
    for (const groupName in data) {
      if (data.hasOwnProperty(groupName)) {
        const group = data[groupName];
        group.forEach((criterion) => {
          result.push({
            value: criterion.value,
            score: criterion.score,
            color: criterion.color,
            comment: criterion.comment,
            criteriaOptionValueIDs: criterion.CriteriaOptions.map(
              (crOp) => crOp.id
            ),
            CriterionId: criterion.Criteria.id,
            CriterionGroupeId: criterion.CriteriaGroupId,
          });
        });
      }
    }
    return result;
  };

  const [data, setData] = useState({
    note: 0,
    DetailEval: [],
    attributs: [],
    ScoreGroupCriteriaEval: [],
    //attributeValueIDs: [],
  });
  const [isOpenComment, setIsOpenComment] = useState({
    displayOpenComment: false,
    id: 0,
  });
  const [sum, setSum] = useState({});
  const [testSum, setTestSum] = useState([]);
  const [total, setTotal] = useState(0);
  const [comment, setcomment] = useState([]);
  const [countCriteriaGroup, setCountCriteriaGroup] = useState(0);
  const [countNbrCriteria, setCountNbrCriteria] = useState(0);
  const [sume, setSume] = useState({});
  const [statuse, setStatuse] = useState({});
  const [statusgc, setStatusgc] = useState({});
  const [color, setColor] = useState({});
  const [selectionOption, setSelectionOption] = useState([]);
  const [selectionOptionMalus, setSelectionOptionMalus] = useState([]);

  useEffect(() => {
    if (props?.DetailSelectedEval && props?.DetailSelectedEval.length > 0) {
      const transformedData = transformData(
        props?.DetailSelectedEval?.[0]?.CriteriaGroup
      );
      let resultStatus = {};
      let resultColor = {};
      let resultTestSum = [];
      let resultselectionOptionMalus = [];
      let resultselectionOptionBonus = [];
      let CountoptionsMalus = [];
      let CountoptionsBonus = [];
      let comments = [];
      props?.grille?.CriteriaGroup.forEach((gc) => {
        gc?.Criteria.forEach((c) => {
          const transformedItem = transformedData.find(
            (item) => item.CriterionId === c.id
          );
          if (transformedItem) {
            const transformedValueId = c?.CriteriaValue?.find(
              (d) => d.name === transformedItem.value
            )?.idCriteriaValue;
            c?.CriteriaValue?.sort(
              (a, b) => a.idCriteriaValue - b.idCriteriaValue
            ).forEach((d) => {
              const existingItem = resultTestSum.find(
                (item) => item.id === c.id
              );
              if (!existingItem) {
                resultTestSum.push({
                  score: transformedItem.score,
                  id: c.id,
                  impactant: c.impact,
                  coefficient: c.coefficient,
                  criteriaGroupeID: c.CriteriaGroupId,
                  NonApplicable:
                    d.name === transformedItem.value && d.NonApplicable,
                });
              }
              if (d.idCriteriaValue <= transformedValueId) {
                resultStatus[d.id] = true;
                resultColor[d.id] = transformedItem.color;
              }
            });
            if (transformedItem.comment !== "") {
              comments.push({
                comment: transformedItem.comment,
                criteriaId: transformedItem.CriterionId,
              });
            }
            let resultselectionOption = c.CriteriaOption.filter(
              (d) =>
                transformedItem.criteriaOptionValueIDs.includes(d.id) &&
                transformedItem.CriterionId === c.id
            );
            resultselectionOption.forEach((item) => {
              if (item.type === "MALUS") {
                resultselectionOptionMalus.push(item);
                let existingEntry = CountoptionsMalus.find(
                  (item) => item.idC === transformedItem.CriterionId
                );
                if (existingEntry) {
                  existingEntry.count += 1;
                } else {
                  CountoptionsMalus.push({
                    count: 1,
                    idC: transformedItem.CriterionId,
                    idOption: transformedItem.criteriaOptionValueIDs[0],
                  });
                }
              } else if (item.type === "BONUS") {
                resultselectionOptionBonus.push(item);
                let existingEntry1 = CountoptionsBonus.find(
                  (item) => item.idC === transformedItem.CriterionId
                );
                if (existingEntry1) {
                  existingEntry1.count += 1;
                } else {
                  CountoptionsBonus.push({
                    count: 1,
                    idC: transformedItem.CriterionId,
                    idOption: transformedItem.criteriaOptionValueIDs[0],
                  });
                }
              }
            });
          }
        });
      });
      setcomment(comments);
      setSelectionOption(resultselectionOptionBonus);
      setSelectionOptionMalus(resultselectionOptionMalus);
      if (resultselectionOptionMalus.length > 0) {
        setDisplayCountMalus(true);
        setCountoptionsMalus(CountoptionsMalus);
      }else {
        setDisplayCountMalus(false);
        setCountoptionsMalus([{ count: 0, idC: 0, idOption: 0 }]);
      }

      if (resultselectionOptionBonus.length > 0) {
        setDisplayCount(true);
        setCountoptions(CountoptionsBonus);
      }else {
        setDisplayCount(false);
        setCountoptions([{ count: 0, idC: 0, idOption: 0 }]);
      }

      setTestSum(resultTestSum);
      setStatuse(resultStatus);
      setColor(resultColor);
      setData({
        ...data,
        DetailEval: transformedData,
        ScoreGroupCriteriaEval:
          props?.DetailSelectedEval?.[0]?.eval?.ScoreGroupCriteriaEval,
        note: props?.DetailSelectedEval?.[0]?.eval?.note,
      });
    } else {
      setData({
        ...data,
        note: 0,
        DetailEval: [],
        ScoreGroupCriteriaEval: [],
        //attributeValueIDs: [],
      });
      setStatuse({});
      setColor({});
      setTestSum([]);
      setcomment([]);
      setSelectionOption([]);
      setDisplayCount(false);
      setCountoptions([{ count: 0, idC: 0, idOption: 0 }]);
      setSelectionOptionMalus([]);
      setDisplayCountMalus(false);
      setCountoptionsMalus([{ count: 0, idC: 0, idOption: 0 }]);
    }
  }, [props?.DetailSelectedEval]);
  const [countoptions, setCountoptions] = useState([
    {
      count: 0,
      idC: 0,
      idOption: 0,
    },
  ]);
  const [displayCount, setDisplayCount] = useState(false);
  const [countoptionsMalus, setCountoptionsMalus] = useState([
    {
      count: 0,
      idC: 0,
      idOption: 0,
    },
  ]);
  const [displayCountMalus, setDisplayCountMalus] = useState(false);
  const [crId, setCrId] = useState();
  const [dataComment, setDataComment] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(ClearGrille());
  }, []);

  useEffect(() => {
    setCountCriteriaGroup(props?.grille?.CriteriaGroup?.length);
    const CountCriteria = props?.grille?.CriteriaGroup?.reduce((acc, item) => {
      return acc + item.Criteria.length;
    }, 0);
    setCountNbrCriteria(CountCriteria);
  }, [props?.grille]);

  let result = 0;
  let countCoef = 0;
  // let finalSumResult
  let array = [];
  let arrayTotal = [];
  let TotalCoef = [];
  var SumTotal = 0;
  let NAArr = [];

  const addBonusOrMalustoScore = (initialScore, optionScore) => {
    let finalScore = initialScore;

    optionScore.forEach((element) => {
      if (element.type === "BONUS" && finalScore < 100) {
        finalScore = finalScore + element.score;
      }
      if (element.type === "MALUS" && finalScore > 0) {
        finalScore = finalScore - element.score;
      }
    });

    if (finalScore > 100) {
      finalScore = 100;
    } else if (finalScore < 0) {
      finalScore = 0;
    }

    return finalScore;
  };
  const getSelectionOptionMalus = (option) => {
    props.setSelectedEval(null);
    let listCriteriaIds;
    let matchedValues = [];

    setSelectionOptionMalus([...selectionOptionMalus, option]);
    const CountOption = countoptionsMalus
      ?.filter((c) => c.idC == option.CriterionId)
      .map((c) => c.count);

    setCountoptionsMalus([
      ...countoptionsMalus?.filter((c) => c.idC !== option.CriterionId),
      {
        count:
          CountOption && CountOption.length > 0
            ? Number(CountOption[0]) + 1
            : 1,
        idC: option.CriterionId,
        idOption: option.id,
      },
    ]);

    setDisplayCountMalus(true);

    if (data.DetailEval && data.DetailEval.length) {
      const DatEval = data?.DetailEval.map((d) => {
        if (d?.CriterionId == option?.CriterionId) {
          matchedValues.push(option?.CriterionId);
          setData({
            ...data,
            DetailEval: [
              ...data.DetailEval?.filter(
                (d) => d.CriterionId !== option?.CriterionId
              ),
              {
                value: d?.value,
                comment: d?.comment,
                criteriaOptionValueIDs: [
                  ...d?.criteriaOptionValueIDs.filter((i) => i !== option.id),
                  option.id,
                ],
                CriterionId: d?.CriterionId,
                CriterionGroupeId: d?.CriterionGroupeId,
                score: d?.score,
                color: d?.color,
              },
            ],
          });
        } else {
          if (!matchedValues.includes(option.CriterionId)) {
            setData({
              ...data,
              DetailEval: [
                ...data.DetailEval,
                {
                  value: "",
                  comment: "",
                  criteriaOptionValueIDs: [option.id],
                  CriterionId: option.CriterionId,
                  CriterionGroupeId: 0,
                  score: 0,
                  color: "",
                },
              ],
            });
          }
        }
      });
    } else {
      setData({
        ...data,
        DetailEval: [
          {
            value: "",
            comment: "",
            criteriaOptionValueIDs: [option.id],
            CriterionId: option.CriterionId,
            CriterionGroupeId: 0,
            score: 0,
            color: "",
          },
        ],
      });
    }

    const selectoption = selectionOptionMalus?.forEach((element) => {
      if (element.id === option.id) {
        setSelectionOptionMalus(
          selectionOptionMalus.filter((element) => element?.id !== option.id)
        );

        setCountoptionsMalus([
          ...countoptionsMalus?.filter((c) => c.idC !== option.CriterionId),
          {
            count:
              CountOption &&
              CountOption.length > 0 &&
              Number(CountOption[0]) - 1,
            idC: option.CriterionId,
            idOption: option.id,
          },
        ]);

        //Eliminate the unselected criteriaoptions from criteriaOptionValueIDs List:
        const FiltredList = data.DetailEval.map((d) => {
          if (d.criteriaId == option.criteriaId) {
            listCriteriaIds = d;
          }
        });
        const criteriaIdsList = listCriteriaIds.criteriaOptionValueIDs.filter(
          (c) => c !== option.id
        );
        listCriteriaIds.criteriaOptionValueIDs = criteriaIdsList;
        setData({
          ...data,
          DetailEval: [
            ...data.DetailEval?.filter(
              (d) => d.CriterionId !== option?.CriterionId
            ),
            listCriteriaIds,
          ],
        });
      }
    });
  };
  const getSelectionOption = (option) => {
    let matchedValues = [];
    let listCriteria;
    props.setSelectedEval(null);
    setSelectionOption([...selectionOption, option]);

    const CountOption = countoptions
      ?.filter((c) => c.idC == option.CriterionId)
      .map((c) => c.count);

    setCountoptions([
      ...countoptions?.filter((c) => c.idC !== option.CriterionId),
      {
        count:
          CountOption && CountOption.length > 0
            ? Number(CountOption[0]) + 1
            : 1,
        idC: option.CriterionId,
        idOption: option.id,
      },
    ]);

    setDisplayCount(true);

    if (data.DetailEval && data.DetailEval.length) {
      const dataEval = data?.DetailEval.map((d) => {
        if (d?.CriterionId == option?.CriterionId) {
          matchedValues.push(option?.CriterionId);
          setData({
            ...data,
            DetailEval: [
              ...data.DetailEval?.filter(
                (d) => d.CriterionId !== option?.CriterionId
              ),
              {
                value: d?.value,
                comment: d?.comment,
                criteriaOptionValueIDs: [
                  ...d?.criteriaOptionValueIDs.filter((i) => i !== option.id),
                  option.id,
                ],
                CriterionId: d?.CriterionId,
                CriterionGroupeId: d?.CriterionGroupeId,
                score: d?.score,
                color: d?.color,
              },
            ],
          });
        } else {
          if (!matchedValues.includes(option.CriterionId)) {
            setData({
              ...data,
              DetailEval: [
                ...data.DetailEval,
                {
                  value: "",
                  comment: "",
                  criteriaOptionValueIDs: [option.id],
                  CriterionId: option.CriterionId,
                  CriterionGroupeId: 0,
                  score: 0,
                  color: "",
                },
              ],
            });
          }
        }
      });
    } else {
      setData({
        ...data,
        DetailEval: [
          {
            value: "",
            comment: "",
            criteriaOptionValueIDs: [option.id],
            CriterionId: option.CriterionId,
            CriterionGroupeId: 0,
            score: 0,
            color: "",
          },
        ],
      });
    }
    const selectoption = selectionOption?.forEach((element) => {
      if (element.id === option.id) {
        setSelectionOption(
          selectionOption.filter((element) => element?.id !== option.id)
        );

        setCountoptions([
          ...countoptions?.filter((c) => c.idC !== option.CriterionId),
          {
            count:
              CountOption &&
              CountOption.length > 0 &&
              Number(CountOption[0]) - 1,
            idC: option.CriterionId,
            idOption: option.id,
          },
        ]);

        //Eliminate the unselected criteriaoptions from criteriaOptionValueIDs List:
        data.DetailEval.map((d) => {
          if (d.criteriaId == option.criteriaId) {
            listCriteria = d;
          }
        });
        const criteriaIdsList = listCriteria.criteriaOptionValueIDs.filter(
          (c) => c !== option.id
        );
        listCriteria.criteriaOptionValueIDs = criteriaIdsList;
        setData({
          ...data,
          DetailEval: [
            ...data.DetailEval?.filter(
              (d) => d.CriterionId !== option?.CriterionId
            ),
            listCriteria,
          ],
        });

        // setCountoptions(countoptions - 1);
      }
    });
  };

  function getSomme(countCriteria, column, criteriaGroupeID, option) {
    array = column.filter(
      (thing, index, self) => index === self.findIndex((t) => t.id === thing.id)
    );

    array = array.filter(
      (obj, index) => obj.criteriaGroupeID === criteriaGroupeID
    );
    array = array.filter((obj, index) => obj.impactant === true);
    NAArr = array.filter((obj, index) => obj.NonApplicable === true);
    array = array.filter((obj, index) => obj.NonApplicable === false);

    //eliminer les Critères Non Applicables.
    if (NAArr) {
      countCriteria -= NAArr.length;
    }

    if (array.length !== 0) {
      result = array?.reduce(function (a, b) {
        return {
          score:
            a.score * (a.coefficient === undefined ? 1 : a.coefficient) +
            b.score * b.coefficient,
        };
      });

      countCoef = array?.reduce(function (a, b) {
        return { coefficient: a.coefficient + b.coefficient };
      });
      if (array.length === countCriteria) {
        arrayTotal = [...arrayTotal, result.score / 100];
        TotalCoef = [...TotalCoef, countCoef.coefficient];

        if (
          data.ScoreGroupCriteriaEval.map((e) => e.GroupCriteriaId).includes(
            criteriaGroupeID
          )
        ) {
          data.ScoreGroupCriteriaEval = [
            ...data.ScoreGroupCriteriaEval.filter(
              (item) => item.GroupCriteriaId !== criteriaGroupeID
            ),
            {
              GroupCriteriaId: criteriaGroupeID,
              score: Math.round(result.score / countCoef.coefficient),
            },
          ];
        } else {
          data.ScoreGroupCriteriaEval.push({
            GroupCriteriaId: criteriaGroupeID,
            score: Math.round(result.score / countCoef.coefficient),
          });
        }

        return Math.round(result.score / countCoef.coefficient);
      }
    }
  }

  function getSommeTotal(arrayTotal, TotalCoef) {
    const initialValue = 0;
    const sumWithInitial = arrayTotal.reduce(
      (previousValue, currentValue) => previousValue + currentValue,
      initialValue
    );

    const SumCoef = TotalCoef.reduce(
      (prevValue, currentValue) => prevValue + currentValue,
      initialValue
    );

    SumTotal = Math.round(sumWithInitial * 100) / 100 / SumCoef;
    SumTotal = Math.round(SumTotal * 100);

    if (arrayTotal.length === countCriteriaGroup) {
      if (SumTotal < 100 && selectionOption) {
        SumTotal = addBonusOrMalustoScore(SumTotal, selectionOption);
      }
      if (SumTotal > 0 && selectionOptionMalus) {
        SumTotal = addBonusOrMalustoScore(SumTotal, selectionOptionMalus);
      }

      return SumTotal;
    }

    return SumTotal;
  }
  useEffect(() => {
    SumTotal = getSommeTotal(arrayTotal, TotalCoef);
    setTotal(SumTotal);
  }, [arrayTotal, TotalCoef]);

  const handelchangeDescription = (e) => {
    let CriteriaComment;
    let matchedValues = [];
    comment?.map((c) => {
      if (c?.criteriaId == crId) {
        CriteriaComment = c?.comment;
        return CriteriaComment;
      }
    });

    if (data?.DetailEval && data?.DetailEval?.length) {
      data?.DetailEval?.map((d) => {
        if (d?.CriterionId == crId) {
          matchedValues.push(crId);
          setData({
            ...data,
            DetailEval: [
              ...data?.DetailEval.filter((d) => d?.CriterionId !== crId),
              {
                value: d?.value,
                comment: CriteriaComment,
                criteriaOptionValueIDs: d?.criteriaOptionValueIDs,
                CriterionId: d?.CriterionId,
                CriterionGroupeId: d?.CriterionGroupeId,
                score: d?.score,
                color: d?.color,
              },
            ],
          });
        } else {
          if (!matchedValues.includes(crId)) {
            setData({
              ...data,
              DetailEval: [
                ...data?.DetailEval,
                {
                  value: "",
                  comment: CriteriaComment,
                  criteriaOptionValueIDs: [],
                  CriterionId: crId,
                  CriterionGroupeId: 0,
                  score: 0,
                  color: "",
                },
              ],
            });
          }
        }
      });
    } else {
      setData({
        ...data,
        DetailEval: [
          {
            value: "",
            comment: CriteriaComment,
            criteriaOptionValueIDs: [],
            CriterionId: crId,
            CriterionGroupeId: 0,
            score: 0,
            color: "",
          },
        ],
      });
    }
    annuler();
  };

  const showDescription = (id) => {
    setCrId(id);
    for (var i = 0; i < comment.length; i++) {
      if (comment[i]?.criteriaId == id) {
        setDataComment(comment[i]?.comment);
        break;
      } else {
        setDataComment("");
      }
    }
  };

  const handelbonu = (id) => {
    let filtere = datagrilleselecet.CriteriaGroup.filter((e) => e.id === id);

    let array =
      filtere[0]?.Criteria && filtere[0]?.Criteria.map((e) => e.CriteriaOption);

    let array2 =
      filtere[0]?.Criteria &&
      filtere[0]?.Criteria.map(
        (e) => e.CriteriaOption && e.CriteriaOption.map((e) => e)
      );
    let name = array2;
    let content = array[0];
    return { content, name };
  };
  const annuler = () => {
    isOpenComment.displayOpenComment = !isOpenComment.displayOpenComment;
    // isOpenComment.id = 0;
    setIsOpenComment({ ...isOpenComment });
  };
  const annulerComment = () => {
    isOpenComment.displayOpenComment = !isOpenComment.displayOpenComment;
    // isOpenComment.id = 0;
    setIsOpenComment({ ...isOpenComment });
    if (data?.DetailEval && data?.DetailEval?.length) {
      data?.DetailEval?.map((d) => {
        if (d?.CriterionId == crId) {
          const previousComment = data?.DetailEval.filter(
            (d) => d?.CriterionId === crId
          )[0].comment;
          const updatedComments = comment.map((c) => {
            if (c?.criteriaId === crId) {
              return {
                ...c,
                comment: previousComment,
              };
            }
            return c;
          });
          setcomment(updatedComments);
          setDataComment(previousComment);
        } else {
          const updatedComments = comment.filter((c) => c?.criteriaId !== crId);
          setcomment(updatedComments);
          setDataComment("");
        }
      });
    } else {
      const updatedComments = comment.filter((c) => c?.criteriaId !== crId);
      setcomment(updatedComments);
      setDataComment("");
    }
  };
  const handelChangeattributId = (attributs) => {
    setData({ ...data, attributs: attributs });
  };
  useImperativeHandle(ref, () => ({
    handleSubmit() {
      if (data.DetailEval.length == countNbrCriteria) {
        props.setIsSaving(true);
        props.setShowmessage(false);
        data.note = total;
        data.TenantId = user?.TenantId;
        data.dateInteraction = new Date().getTime();
        data.gridId = props.grille.id;
        data.agentId = props.agent;
        data.evaluateurId = props.organisateur;
        data.idCall = props.idCalibrage;
        dispatch(createEvalReference(data))
        .then(() => {
          props.setDisplay("block");
          setTimeout(() => {
            props.setIsSaving(false);
            history.push("quality-monitoring?id=3");
          }, 3000);
        })
        .catch(() => {
          props.setIsSaving(true);
          props.setDisplay("block");
        });

      } else {
        props.setDisplay("block");
        props.setShowmessage(true);
      }
    },
  }));

  const changeComment = (option) => {
    setcomment([
      ...comment?.filter((c) => c.criteriaId !== crId),
      { comment: option.target.value, criteriaId: crId },
    ]);
    setDataComment(option.target.value);
  };
  const popover = (
    <Tooltip id="tooltip-bottom-input" style={{ opacity: 1 }}>
      <Form.Control
        className="textarea-comment-reference"
        as="textarea"
        rows={3}
        disabled={props?.isDisabled}
        value={dataComment && dataComment}
        onChange={(e) => {
          changeComment(e);
        }}
      />
      <div className="buttons-of-textarea-comment">
        <span
          style={{ color: "#B7B7B7", cursor: "pointer" }}
          onClick={annulerComment}
        >
          Annuler
        </span>
        <span
          style={{ color: "#5800e2", cursor: "pointer" }}
          onClick={handelchangeDescription}
        >
          Ajouter
        </span>
      </div>
    </Tooltip>
  );
  return (
    <div className="card refCard">
      <div id="eval-reference-body">
        <div>
          <div className="container-of-eval-reference">
            <div className="evaluator-container">
              <span className="tiltle-eval-reference">
                {" "}
                Evaluation de réference{" "}
              </span>
              <div className="container-score-eval-reference">
                <span
                  style={{ fontFamily: "Gilroy-Semibold", color: "#B7B7B7" }}
                >
                  {" "}
                  Score Total :
                </span>
                <span className="detail-eval_score">
                  {" "}
                  {isNaN(total) || total === undefined ? (
                    <span> 0 </span>
                  ) : (
                    total
                  )}
                </span>
              </div>
            </div>
            <hr className="hr-eval-ref-card" />
            {props?.grille?.CriteriaGroup &&
              props?.grille?.CriteriaGroup.map((gc, igc) => (
                <div className="container-relationnel-calib">
                  <div className="header-relationnel-eval-calib">
                    <span className="header-relationnel_text-eval-calib">
                      {gc.name}
                    </span>
                    <span className="score-grp-eval-calib">
                      {getSomme(
                        gc.Criteria.filter((obj, index) => obj.impact === true)
                          .length,
                        testSum,
                        gc.id,
                        selectionOption
                      )}
                    </span>
                  </div>
                  {gc?.Criteria?.map((c, ic) => (
                    <div className="row containers-of-eval-ref align-items-center">
                      <div
                        className="col-9"
                        onClick={() => {
                          setDisplayParam({
                            statuse: false,
                            idg: 0,
                            idc: 0,
                          });
                        }}
                      >
                        {c.name}
                      </div>
                      <div className="row right-icons-eval-reference">
                        <div className="col margin-left-right">
                          {displayCount &&
                          countoptions
                            .filter((cp) => cp.idC == c?.id)
                            .map((item) => item.idC)
                            .includes(c?.id) ? (
                            //  && countoptions.filter(cp => cp.idC == c?.id).map(item => item.count)[0] > 0
                            <div className="flex-space-between container-cercle-like">
                              {
                                countoptions
                                  .filter((cp) => cp.idC == c?.id)
                                  .map((item) => item.count)[0]
                              }
                            </div>
                          ) : null}
                          <PopoverBonus
                            selectionOption={selectionOption}
                            getSelectionOption={getSelectionOption}
                            val={c?.CriteriaOption.filter(
                              (e) => e?.type === "BONUS"
                            )}
                            isDisabled={props?.isDisabled}
                          />
                        </div>
                        <div className="col margin-left-right">
                          {displayCountMalus &&
                          countoptionsMalus
                            .filter((cp) => cp.idC == c?.id)
                            .map((item) => item.idC)
                            .includes(c?.id) ? (
                            // && countoptionsMalus.filter(cp => cp.idC == c?.id).map(item => item.count)[0] > 0
                            <div className="container-cercle-dislike">
                              {
                                countoptionsMalus
                                  .filter((cp) => cp.idC == c?.id)
                                  .map((item) => item.count)[0]
                              }
                            </div>
                          ) : null}
                          <Popovermalus
                            selectionOption={selectionOptionMalus}
                            getSelectionOption={getSelectionOptionMalus}
                            val={c?.CriteriaOption.filter(
                              (e) => e?.type === "MALUS"
                            )}
                            isDisabled={props?.isDisabled}
                          />
                        </div>
                        {isOpenComment.displayOpenComment &&
                        isOpenComment.id === ic ? (
                          <>
                            <div className="col margin-left-right">
                              <div
                                onClick={() => {
                                  if(props?.isDisabled) return;
                                  setIsOpenComment({
                                    displayOpenComment: false,
                                    id: ic,
                                  });
                                  setCrId("");
                                  // showDescription();
                                }}
                              >
                                <img
                                  className="img-chat-position"
                                  // width={20}
                                  alt=""
                                  src={iconChat}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="col margin-left-right">
                            {comment.some(
                              (item) =>
                                item?.criteriaId === c?.id &&
                                item?.comment !== ""
                              ) && <div className="container-cercle-like">1</div>
                            }
                            <OverlayTrigger
                              trigger="click"
                              rootClose
                              placement="bottom-end"
                              overlay={popover}
                            >
                              <img
                                className="img-chat-position2"
                                // width={20}
                                src={iconChat}
                                alt=""
                                onClick={() => {
                                  if(props?.isDisabled) return;
                                  setIsOpenComment({
                                    displayOpenComment: false,
                                    id: ic,
                                    crId: ic,
                                  });
                                  //setCrId(c?.id);
                                  showDescription(c?.id);
                                }}
                              />
                            </OverlayTrigger>
                          </div>
                        )}
                      </div>
                      <div className="col d-flex">
                        {c?.CriteriaValue?.sort((a, b) => {
                          return a.idCriteriaValue - b.idCriteriaValue;
                        }).map(function (d, idx) {
                          return (
                            <div
                              key={idx}
                              className="container-sub-grid"
                              onClick={() => {
                                if(props?.isDisabled) return;
                                if (
                                  !data.DetailEval.map(
                                    (e) => e.CriterionId
                                  ).includes(c.id)
                                ) {
                                  data.DetailEval.push({
                                    value: d.name,
                                    score: d.score,
                                    color: d.color,
                                    comment: "",
                                    criteriaOptionValueIDs: [],
                                    CriterionId: c.id,
                                    CriterionGroupeId: gc.id,
                                  });
                                  setData({
                                    ...data,
                                    DetailEval: [...data.DetailEval],
                                  });
                                } else {
                                  props.setSelectedEval(null);
                                  const detailEvalIndex = data.DetailEval.findIndex((e) => e.CriterionId === c.id);
                                  data.DetailEval[detailEvalIndex] = {
                                    value: d.name,
                                    score: d.score,
                                    color: d.color,
                                    comment: data.DetailEval[detailEvalIndex]?.comment, 
                                    criteriaOptionValueIDs: data.DetailEval[detailEvalIndex]?.criteriaOptionValueIDs, 
                                    CriterionId: c.id,
                                    CriterionGroupeId: gc.id,
                                  };
                                  // if (igc === 0) {
                                  //   data.DetailEval[ic] = {
                                  //     value: d.name,
                                  //     score: d.score,
                                  //     color: d.color,
                                  //     comment: data.DetailEval[ic]?.comment,
                                  //     criteriaOptionValueIDs:
                                  //       data.DetailEval[ic]
                                  //         ?.criteriaOptionValueIDs,
                                  //     CriterionId: c.id,
                                  //     CriterionGroupeId: gc.id,
                                  //   };
                                  //   setData({
                                  //     ...data,
                                  //     DetailEval: [...data.DetailEval],
                                  //   });
                                  // } else {
                                  //   data.DetailEval[
                                  //     data.DetailEval.length - 1
                                  //   ] = {
                                  //     value: d.name,
                                  //     score: d.score,
                                  //     color: d.color,
                                  //     comment: data.DetailEval[ic]?.comment,
                                  //     criteriaOptionValueIDs:
                                  //       data.DetailEval[ic]
                                  //         ?.criteriaOptionValueIDs,
                                  //     CriterionId: c.id,
                                  //     CriterionGroupeId: gc.id,
                                  //   };
                                  //   setData({
                                  //     ...data,
                                  //     DetailEval: [...data.DetailEval],
                                  //   });
                                  // }
                                }
                                if (testSum.length === 0) {
                                  setTestSum([
                                    ...testSum,
                                    {
                                      score: d.score,
                                      id: c.id,
                                      impactant: c.impact,
                                      coefficient: c.coefficient,
                                      criteriaGroupeID: gc.id,
                                      NonApplicable: d.NonApplicable,
                                    },
                                  ]);
                                } else {
                                  testSum.forEach((ob) => {
                                    if (ob.id !== c.id) {
                                      setTestSum([
                                        ...testSum,
                                        {
                                          score: d.score,
                                          id: c.id,
                                          impactant: c.impact,
                                          coefficient: c.coefficient,
                                          criteriaGroupeID: gc.id,
                                          NonApplicable: d.NonApplicable,
                                        },
                                      ]);
                                    } else {
                                      ob.score = d.score;
                                      ob.NonApplicable = d.NonApplicable;
                                    }
                                  });
                                }
                                setColorParam({
                                  id: d.id,
                                  color: d.color,
                                  name: d.name,
                                  value: d.score,
                                  comment: d.description,
                                });
                                setDisplayParam({
                                  statuse: !displayParam.status,
                                  idc: c.id,
                                  idg: gc.id,
                                });
                                !statuse[d.id]
                                  ? c.CriteriaValue.slice(0, idx + 1).forEach(
                                      (item, key) => {
                                        statuse[item.id] = true;
                                        color[item.id] = d.color;
                                      }
                                    )
                                  : c.CriteriaValue.slice(idx + 1).forEach(
                                      (item, key) => {
                                        statuse[item.id] = false;
                                        color[item.id] = "none";
                                      }
                                    );

                                setStatuse({ ...statuse });
                                setColor({ ...color });

                                statusgc[c.id] = d.score;
                                c.CriteriaValue.slice(0, idx + 1).forEach(
                                  (item, key) => {
                                    statuse[item.id] = true;
                                    color[item.id] = d.color;
                                  }
                                );
                                setColor({ ...color });
                                setStatusgc({ ...statusgc });

                                if (sum[igc]) {
                                  if (
                                    gc?.Criteria?.map((e) => e.id).length > 1
                                  ) {
                                    for (
                                      let i = 1;
                                      i < gc?.Criteria?.map((e) => e.id).length;
                                      i++
                                    ) {
                                      if (
                                        statusgc[
                                          gc?.Criteria?.map((e) => e.id)[i]
                                        ]
                                      ) {
                                        sum[igc] =
                                          statusgc[
                                            gc?.Criteria?.map((e) => e.id)[0]
                                          ] +
                                          statusgc[
                                            gc?.Criteria?.map((e) => e.id)[i]
                                          ];
                                      } else {
                                        sum[igc] =
                                          statusgc[
                                            gc?.Criteria?.map((e) => e.id)[0]
                                          ];
                                      }
                                    }
                                  } else {
                                    if (
                                      statusgc[
                                        gc?.Criteria?.map((e) => e.id)[1]
                                      ]
                                    ) {
                                      sum[igc] =
                                        statusgc[
                                          gc?.Criteria?.map((e) => e.id)[0]
                                        ] +
                                        statusgc[
                                          gc?.Criteria?.map((e) => e.id)[1]
                                        ];
                                    } else {
                                      sum[igc] =
                                        statusgc[
                                          gc?.Criteria?.map((e) => e.id)[0]
                                        ];
                                    }
                                  }
                                } else {
                                  sum[igc] = statusgc[c.id];
                                }

                                setSum({ ...sum });

                                sume[igc] = sum[igc];
                                setSume({ ...sume });
                              }}
                            >
                              <span>{d.name}</span>

                              {statuse[d.id] ? (
                                <div
                                  style={{ backgroundColor: color[d.id] }}
                                  className="bar"
                                ></div>
                              ) : (
                                <div className="bar"></div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
});
export default EvaluationReference;
